/* eslint-disable max-len */
import { HealthSurveillanceQuestionConfig, MedicalTypeIds } from "../models";

import * as questionIds from "./questionIds";

const section6MedicalTypes = [
    MedicalTypeIds.Skin,
    MedicalTypeIds.SkinFaceToFace,
    MedicalTypeIds.LAAWorker,
    MedicalTypeIds.SkinLevel1,
    MedicalTypeIds.SkinFaceToFaceLevel1,
    MedicalTypeIds.SkinAssessmentLevel2
];

/**
 * @deprecated Prefer sections exported from `import { sections } from "../questionnaire";` which is in a data structure suitable for use with custom medicals
 */
export const section6Questions: HealthSurveillanceQuestionConfig[] = [
    {
        id: questionIds.EverHadEczema,
        questionText: "Eczema",
        medicalTypes: section6MedicalTypes
    },
    {
        id: questionIds.EverHadEczemaFurtherDetails,
        questionText: "Please provide details",
        medicalTypes: section6MedicalTypes
    },
    {
        id: questionIds.EverHadFoodAllergies,
        questionText: "Food Allergies",
        medicalTypes: section6MedicalTypes
    },
    {
        id: questionIds.EverHadFoodAllergiesFurtherDetails,
        questionText: "Please provide details",
        medicalTypes: section6MedicalTypes
    },
    {
        id: questionIds.WearLatexOrProtectiveGloves,
        questionText: "Do you wear latex or any kind of protective gloves whilst at work?",
        medicalTypes: section6MedicalTypes
    },
    {
        id: questionIds.LatexNitrilePolyVinylGloves,
        questionText: "Please clarify if you use Latex, Nitrile or Poly Vinyl gloves and if they are low protein and powder free?",
        medicalTypes: section6MedicalTypes
    },
    {
        id: questionIds.HowMuchTimeWearingGloves,
        questionText: "How much time do you spend wearing gloves per day?",
        medicalTypes: section6MedicalTypes
    },
    {
        id: questionIds.BarrierCream,
        questionText: "Do you use barrier cream?",
        medicalTypes: section6MedicalTypes
    },
    {
        id: questionIds.BarrierCreamFurtherDetails,
        questionText: "Please provide details",
        medicalTypes: section6MedicalTypes
    },
    {
        id: questionIds.MoisturisingCream,
        questionText: "Do you use moisturising cream?",
        medicalTypes: section6MedicalTypes
    },
    {
        id: questionIds.MoisturisingCreamFurtherDetails,
        questionText: "Please provide details",
        medicalTypes: section6MedicalTypes
    },
    {
        id: questionIds.RednessDrynessCracking,
        questionText: "Redness, Dryness or Cracking?",
        medicalTypes: section6MedicalTypes
    },
    {
        id: questionIds.RednessDrynessCrackingFurtherDetails,
        questionText: "Please provide details",
        medicalTypes: section6MedicalTypes
    },
    {
        id: questionIds.RashAfterWearingGloves,
        questionText: "Rash on hands / general rash after wearing gloves?",
        medicalTypes: section6MedicalTypes
    },
    {
        id: questionIds.RashAfterWearingGlovesFurtherDetails,
        questionText: "Please provide details",
        medicalTypes: section6MedicalTypes
    },
    {
        id: questionIds.SwollenEyesAfterWearingGloves,
        questionText: "Red or swollen eyes after wearing gloves?",
        medicalTypes: section6MedicalTypes
    },
    {
        id: questionIds.SwollenEyesAfterWearingGlovesFurtherDetails,
        questionText: "Please provide details",
        medicalTypes: section6MedicalTypes
    },
    {
        id: questionIds.InflammationMucousMembranes,
        questionText: "Inflammation of mucous membranes in the nose – rhinitis?",
        medicalTypes: section6MedicalTypes
    },
    {
        id: questionIds.InflammationMucousMembranesFurtherDetails,
        questionText: "Please provide details",
        medicalTypes: section6MedicalTypes
    },
    {
        id: questionIds.AsthmaSymptoms,
        questionText: "Asthma like symptoms?",
        medicalTypes: section6MedicalTypes
    },
    {
        id: questionIds.AsthmaSymptomsFurtherDetails,
        questionText: "Please provide details",
        medicalTypes: section6MedicalTypes
    },
    {
        id: questionIds.ItchingBlistersAfterWearingGloves,
        questionText: "Itching or red blisters sometimes after wearing gloves?",
        medicalTypes: section6MedicalTypes
    },
    {
        id: questionIds.ItchingBlistersAfterWearingGlovesFurtherDetails,
        questionText: "Please provide details",
        medicalTypes: section6MedicalTypes
    },
    {
        id: questionIds.DryFlakySkin,
        questionText: "Dry / flaky skin",
        medicalTypes: section6MedicalTypes
    },
    {
        id: questionIds.DryFlakySkinFurtherDetails,
        questionText: "Please provide details",
        medicalTypes: section6MedicalTypes
    },
    {
        id: questionIds.AllergicSkinReactions,
        questionText: "Allergic skin reactions",
        medicalTypes: section6MedicalTypes
    },
    {
        id: questionIds.AllergicSkinReactionsFurtherDetails,
        questionText: "Please provide details",
        medicalTypes: section6MedicalTypes
    },
    {
        id: questionIds.RednessSwellingSkin,
        questionText: "Redness / swelling of skin",
        medicalTypes: section6MedicalTypes
    },
    {
        id: questionIds.RednessSwellingSkinFurtherDetails,
        questionText: "Please provide details",
        medicalTypes: section6MedicalTypes
    },
    {
        id: questionIds.ItchySkin,
        questionText: "Itchy skin",
        medicalTypes: section6MedicalTypes
    },
    {
        id: questionIds.ItchySkinFurtherDetails,
        questionText: "Please provide details",
        medicalTypes: section6MedicalTypes
    },
    {
        id: questionIds.OtherRashes,
        questionText: "Other rashes / blisters / spots",
        medicalTypes: section6MedicalTypes
    },
    {
        id: questionIds.OtherRashesFurtherDetails,
        questionText: "Please provide details",
        medicalTypes: section6MedicalTypes
    },
    {
        id: questionIds.SkinImproveAwayFromWork,
        questionText: "Does the condition improve when away from work?",
        medicalTypes: section6MedicalTypes
    },
    {
        id: questionIds.SkinImproveAwayFromWorkFurtherDetails,
        questionText: "Please provide details",
        medicalTypes: section6MedicalTypes
    },
    {
        id: questionIds.ReceivingTreatmentAtPresent,
        questionText: "Are you receiving treatment at present?",
        medicalTypes: section6MedicalTypes
    },
    {
        id: questionIds.ReceivingTreatmentAtPresentFurtherDetails,
        questionText: "Please provide details",
        medicalTypes: section6MedicalTypes
    }
];
/* eslint-enable max-len */
